const ERoutes = {
  "PAYMENT": "/payment"
}

export default ERoutes;